import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const highlightValueStyles = css`
  align-items: center;
  border-radius: ${theme.borderRadius.medium};
  display: flex;
  min-height: 135px;
  overflow: hidden;
  padding: ${theme.spacing(3)};
  position: relative;

  .message {
    max-width: calc(100% - 100px);
  }

  .graphic {
    width: 110px;
    position: absolute;
    right: ${theme.spacing(1)};
  }

  @container (min-width: ${breakpoints.xsmall.max}px) {
    .message {
      max-width: calc(100% - 120px);
    }

    .graphic {
      width: 140px;
    }
  }

  @container (min-width: ${breakpoints.medium.max}px) {
    .message {
      max-width: 620px;
    }

    .graphic {
      height: 135px;
      width: auto;
      max-width: 200px;
    }
  }

  @container (min-width: ${breakpoints.mobile.max}px) {
    .graphic {
      right: 60px;
    }
  }

  * {
    font-size: ${theme.fontSize(24)} !important;
  }
`;

export const summaryTabsStyles = {
  mainWrapper: css`
    border-radius: ${theme.borderRadius.medium};
    border: 1px solid ${theme.colors.neutral20};
    padding: ${theme.spacing(3)};
    position: relative;
  `,

  statsWrapper: css`
    align-items: baseline;
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.spacing(3)};
    justify-content: space-between;

    @container (min-width: 700px) {
      flex-wrap: nowrap;
    }
  `,
};
